export const APP_URLS = {
    FOOTER_URLS: {
        MARKET: '/markets',
        TRADING_FEE: '/user/my-fees',
        API: 'https://docs.coinflare.com',
        HELP: 'https://coinflarehelp.zendesk.com/hc/en-us',
    },
    FUNDING_RATE_DETAIL_URL: '/contract/history/rates/',
    LOGIN: '/login',
    REGISTER: '/register',
    HOME: '/',
    CONTRACT: '/contract',
    CONTRACT_DETAIL: '/contract/history/introduction',
    SPOT: '/spot',
    TOKEN_INFO: `/coin-info/`,
    LIQ_PRICE_HELP:
        'https://help.coinflare.com/hc/en-us/articles/11828757089945-Liquidation-Protocols',
    POSITION_MARGIN_HELP:
        'https://help.coinflare.com/hc/en-us/articles/11828844699417-What-is-Order-Cost-Initial-Margin-and-Maintenance-Margin-',
    REALIZED_PL_HELP:
        'https://help.coinflare.com/hc/en-us/articles/6335580051481-How-to-Calculate-Profit-and-Loss-for-Perpetual-Contracts-',
    ALL_SPOT_ORDERS: '/orders/spot',
};
